var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.label,"type":"text","rules":_vm.validationRules,"disabled":_vm.disabled,"filled":""},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }